import * as React from "react";
import { Container, Text, TokenTextAppearance, } from "@volkswagen-onehub/components-core";
import { StyledTable } from "../Table";
import { RegisterVersionRow } from "./RegisterVersionRow";
import { RegisterVersionDangerZone } from "./RegisterVersionDangerZone";
import { registerFeatureAppAction } from "./registerFeatureAppAction";
import { ServiceContext } from "../../context/ServiceContext";
import { RegisterFeatureAppContext } from "./RegisterFeatureAppContext";
import { TRANSITION_PROD_DEPLOYMENT, TRANSITION_READY_FOR_TEST, } from "./TransitionIDs";
export const RegisterFeatureAppComponent = (props) => {
    const { name, releases, production, stage, integration, appStoreAppId } = props;
    const layerManager = React.useContext(ServiceContext).layerManager;
    const registrationAllowedMap = {
        prod: production.registrationAllowed,
        int: integration.registrationAllowed,
        stage: stage.registrationAllowed,
    };
    const latestRelease = releases[0];
    const prodVersion = {
        name: "stage version",
        version: stage.version || "",
    };
    const intVersion = {
        name: "stage version",
        version: stage.version || "",
    };
    const stageVersion = {
        name: "latest version",
        version: latestRelease ? latestRelease.version : "",
    };
    const reloadFromContext = React.useContext(RegisterFeatureAppContext);
    const jiraComment = "[KUMS] Registration done with OneHub Manager for ";
    const execute = registerFeatureAppAction(layerManager, releases, {
        prod: production.configurations,
        int: integration.configurations,
        stage: stage.configurations,
    }, {
        prod: {
            transitionId: TRANSITION_PROD_DEPLOYMENT,
            comment: jiraComment + "prod",
        },
        stage: {
            transitionId: TRANSITION_READY_FOR_TEST,
            comment: jiraComment + "stage",
        },
    }, `Register`, name, reloadFromContext.reload, appStoreAppId);
    return (React.createElement(Container, { gutter: "dynamic0200", wrap: "always" },
        React.createElement(Text, { appearance: TokenTextAppearance.headline300 }, "Registration"),
        React.createElement(StyledTable, null,
            React.createElement("tbody", null,
                React.createElement(RegisterVersionRow, { name: production.name, currentVersion: production.version, envId: production.id, execute: execute, newVersion: prodVersion, registrationAllowed: production.registrationAllowed, lastDeploymentDate: production.lastDeploymentDate }),
                React.createElement(RegisterVersionRow, { name: integration.name, currentVersion: integration.version, envId: integration.id, execute: execute, newVersion: intVersion, registrationAllowed: integration.registrationAllowed, lastDeploymentDate: integration.lastDeploymentDate }),
                React.createElement(RegisterVersionRow, { name: stage.name, currentVersion: stage.version, envId: stage.id, execute: execute, newVersion: stageVersion, registrationAllowed: stage.registrationAllowed, lastDeploymentDate: stage.lastDeploymentDate }))),
        React.createElement(RegisterVersionDangerZone, { releases: releases, execute: execute, registrationAllowed: registrationAllowedMap, currentVersions: {
                prod: production.version,
                int: integration.version,
                stage: stage.version,
            } })));
};
export function getTicketId(release) {
    const jiraIds = release.app
        .filter((conf) => Boolean(conf.jiraId))
        .map((conf) => conf.jiraId);
    return jiraIds.length >= 1 ? jiraIds[0] : undefined;
}
export function getChanges(configurations, env, release) {
    const configs = configurations[env] ?? [];
    const fallbackBasePath = getFeatureAppConfigsBasePath(configurations, env);
    return release.app.reduce((changes, releaseConfig) => {
        const envConfig = configs.find((cfg) => matchesConfig(releaseConfig, cfg));
        if (!releaseConfig.name) {
            return changes;
        }
        const fallbackPath = fallbackBasePath
            ? `${fallbackBasePath}/${releaseConfig.name}`
            : undefined;
        const path = envConfig?.path ?? fallbackPath;
        if (!path) {
            return changes;
        }
        changes.push({
            path,
            name: releaseConfig.name,
            oldVersion: envConfig,
            newVersion: releaseConfig,
        });
        return changes;
    }, []);
}
function getFeatureAppConfigsBasePath(configurations, preferredEnv) {
    const envPaths = (configurations[preferredEnv] || [])
        .map((config) => config.path)
        .filter((path) => Boolean(path));
    const samplePath = envPaths[0];
    if (!samplePath) {
        return undefined;
    }
    const parts = samplePath.split("/").filter(Boolean);
    if (parts.length <= 1) {
        return undefined;
    }
    return `/${parts.slice(0, -1).join("/")}`;
}
function matchesConfig(a, c) {
    return c.groupName === a.name || c.name === a.name;
}
